import React from 'react'

export const YoutubeIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="44.621" height="44.619" viewBox="0 0 44.62 44.619">
      <defs>
        <linearGradient id="primarySecondary" gradientUnits="userSpaceOnUse" x1="23.2212" y1="26.9795" x2="23.2212" y2="17.6401">
          <stop offset="0" stopColor="#262355" />
          <stop offset="1" stopColor="#bab5ff" />
        </linearGradient>
      </defs>
      <g id="youtube-icon">
        <path fill="yellow" d="M18.721 17.64l9 4.67-9 4.669z" />
        <path fill="yellow" d="M0 0v44.619h44.621V0H0zm37.32 28.119c-.32 2.21-.859 3.87-3.189 4.46-1.051.271-3.221.301-5.43.351-3.16.091-6.391.12-6.391.12s-3.23-.029-6.39-.12c-2.221-.05-4.381-.079-5.431-.351-2.34-.59-2.88-2.25-3.189-4.46-.37-2.619-.37-9 0-11.619.31-2.21.85-3.86 3.189-4.46 1.05-.271 3.21-.29 5.431-.351 3.159-.09 6.39-.12 6.39-.12s3.229.03 6.391.12c2.209.061 4.379.08 5.43.351 2.33.6 2.869 2.25 3.189 4.46.37 2.619.37 9 0 11.619z" />
      </g>
    </svg>
  )
}
